export default "__VITE_ASSET__Do8S90J3__"